module.exports = __webpack_public_path__ + "522d898c19396a45caa51ed0f0f2543e.svg";